import React from 'react';

import {SvgProps} from '../../helpers/type';

const Briefcase = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="0.711523"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                fill="#EDFCF2"
                fillOpacity="0.5"
            />
            <path
                d="M29.0212 15.6889H25.3057C24.9324 14.6578 23.9546 13.9111 22.799 13.9111C21.6435 13.9111 20.6657 14.6578 20.2924 15.6889H16.5768C15.599 15.6889 14.799 16.4889 14.799 17.4667V29.9111C14.799 30.8889 15.599 31.6889 16.5768 31.6889H29.0212C29.999 31.6889 30.799 30.8889 30.799 29.9111V17.4667C30.799 16.4889 29.999 15.6889 29.0212 15.6889ZM22.799 15.6889C23.2879 15.6889 23.6879 16.0889 23.6879 16.5778C23.6879 17.0667 23.2879 17.4667 22.799 17.4667C22.3101 17.4667 21.9101 17.0667 21.9101 16.5778C21.9101 16.0889 22.3101 15.6889 22.799 15.6889ZM21.0212 28.1333L17.4657 24.5778L18.719 23.3244L21.0212 25.6178L26.879 19.76L28.1324 21.0222L21.0212 28.1333Z"
                fill="#5D847F"
            />
            <rect
                x="0.711523"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default Briefcase;
